import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import React from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ProfileDonorInfo = () => {
  return (
    <Card className="mb-3">
      <FalconCardHeader
        title={<h4 className="fw-bold">Donor information</h4>}
        light={false}
        titleTag="div"
        className="pb-1"
        menuClassName="align-items-start"
        endEl={
          <IconButton
            icon="pen"
            variant="falcon-default"
            transform="shrink-3"
            className="fs--1 bg-transparent shadow-none"
          >
            Quick Update
          </IconButton>
        }
      />
      <Card.Body>
        <Row>
          <Col>
            <Flex>
              <div className="donar-info-title">
                <p className="mb-2">Title</p>
                <p className="mb-0">Name</p>
              </div>
              <div>
                <p className="mb-2">Mr.</p>
                <Link to={'#'} className="mb-0">
                  Ahmed Hassan Amin
                </Link>
              </div>
            </Flex>
            <hr />
            <Flex>
              <div className="donar-info-title">
                <p>Address</p>
              </div>
              <div>
                <p className="mb-2">Akshya Nagar 1st Block 1st Cross 1611</p>
                <p className="mb-0">4678 Maud Street, Philadelphia, DE 19103</p>
              </div>
            </Flex>
            <hr />
            <Flex>
              <div className="donar-info-title">
                <p>Phone No.</p>
              </div>
              <div>
                <Flex>
                  <p className="mb-2">+(20) 1020304050</p>
                  <Form.Group className="ms-3" controlId={`phone-control-1`}>
                    <Flex>
                      <Form.Check
                        inline
                        type="radio"
                        name="phone"
                        id={`phone-control-1`}
                        value={`phone`}
                        className="me-2"
                      />
                      <Form.Label className="mb-0">Primary</Form.Label>
                    </Flex>
                  </Form.Group>
                </Flex>
                <Flex>
                  <p className="mb-0">+(20) 1020304050</p>
                  <Form.Group className="ms-3" controlId={`phone-control-2`}>
                    <Flex>
                      <Form.Check
                        inline
                        type="radio"
                        name="phone"
                        id={`phone-control-2`}
                        value={`phone`}
                        className="me-2"
                      />
                      <Form.Label className="mb-0">Primary</Form.Label>
                    </Flex>
                  </Form.Group>
                </Flex>
              </div>
            </Flex>
            <hr />
            <Flex>
              <div className="donar-info-title">
                <p>E-Mail</p>
              </div>
              <div>
                <Flex>
                  <p className="mb-2">Email@Example.com</p>
                  <Form.Group className="ms-3" controlId={`email-control-1`}>
                    <Flex>
                      <Form.Check
                        inline
                        type="radio"
                        name="email"
                        id={`email-control-1`}
                        value={`email`}
                        className="me-2"
                      />
                      <Form.Label className="mb-0">Primary</Form.Label>
                    </Flex>
                  </Form.Group>
                </Flex>
                <Flex>
                  <p className="mb-0">Personal@test.net</p>
                  <Form.Group className="ms-3" controlId={`email-control-2`}>
                    <Flex>
                      <Form.Check
                        inline
                        type="radio"
                        name="email"
                        id={`email-control-2`}
                        value={`email`}
                        className="me-2"
                      />
                      <Form.Label className="mb-0">Primary</Form.Label>
                    </Flex>
                  </Form.Group>
                </Flex>
              </div>
            </Flex>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ProfileDonorInfo;
